import tradeDataStore from "@/store/tradeDataStore";
import featureFlagStore from "@/store/featureFlagStore";
import { useAuth0 } from "@auth0/auth0-react";
import ActionSummaryTable from "./ActionSummaryTable";

const ActionSummaryIndex = ({ cryptoID }: { cryptoID: string }) => {
  const { getAccessTokenSilently, user } = useAuth0();
  const dataForMainTable = tradeDataStore((state) => state.tradeData);
  const readyToLoadFlag = tradeDataStore((state) => state.tradeDataHasReturned);
  const featureFlagsLoaded = featureFlagStore((state) => state.featureFlagsLoaded);

  // Gate: don't render the grid until feature flags are resolved.
  // Both the sidebar panel and cog column are configured in useMemo calls that
  // run exactly once on first mount — flags must be known before that happens.
  if (!featureFlagsLoaded) return null;

  return (
    <div className="h-full w-full">
      <ActionSummaryTable
        cryptoID={cryptoID}
        getAccessTokenSilently={getAccessTokenSilently}
        user={user}
        dataForMainTable={readyToLoadFlag ? dataForMainTable : []}
      />
    </div>
  );
};

export default ActionSummaryIndex;
